import { useState } from 'react';
import type { Conversation } from '../api/types';
import { Avatar } from '../components/Avatar';
import { IconClose, IconPhone, IconVideo } from '../components/Icons';
import { startCall } from '../calls/callManager';

export function PeerProfile({ conv, onClose }: { conv: Conversation; onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  const u = conv.peer;
  const copy = async () => {
    await navigator.clipboard?.writeText(u.id).catch(() => {});
    setCopied(true);
  };
  const call = (media: 'audio' | 'video') => {
    onClose();
    void startCall(conv, media);
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal profile" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Профиль">
        <button className="icon-btn modal-close" onClick={onClose} aria-label="Закрыть">
          <IconClose />
        </button>
        <Avatar user={u} size={96} />
        <h2>{u.displayName}</h2>
        {u.username && <p className="muted">@{u.username}</p>}
        <button className="user-id" onClick={copy} title="Скопировать ID">
          ID: {u.id} {copied && <span className="muted">— скопировано</span>}
        </button>
        <div className="profile-actions">
          <button className="btn" onClick={() => call('audio')}>
            <IconPhone size={18} /> Аудиозвонок
          </button>
          <button className="btn" onClick={() => call('video')}>
            <IconVideo size={18} /> Видеозвонок
          </button>
        </div>
      </div>
    </div>
  );
}
